import React from "react";
import PropTypes from "prop-types";

import { defaultPropFunction } from "utils";
import IconArrow from "components/Icon/Arrow";
import {
  Container,
  Button,
  ButtonBar,
  FirstButton,
  DisplayRowsSelector,
  Select
} from "./Pagination.styles";

const range = (start, end) =>
  [...Array(end - start).keys()].map(n => n + start);

const UIPagination = props => {
  const {
    activePage,
    startPage,
    endPage,
    hasNextPage,
    hasPrevPage,
    displaying,
    displayOptions,
    onChangePage,
    onNextPage,
    onPrevPage,
    onFirstPage,
    onLastPage,
    onChangeDisplaying
  } = props;

  const pageButtons = range(startPage, endPage + 1).map(n => (
    <Button
      key={n}
      title={`Go to page ${n}`}
      active={n === activePage}
      onClick={() => onChangePage(n)}
      id={`page_${n}`}
    >
      {n}
    </Button>
  ));

  return (
    <Container>
      <ButtonBar>
        <FirstButton
          title="Go to First Page"
          key={"First"}
          onClick={onFirstPage}
          disabled={!hasPrevPage}
          id="first_page"
        >
          <IconArrow rightpadded />
          First
        </FirstButton>
        <Button
          title="Previous page"
          key={"Previous"}
          onClick={onPrevPage}
          disabled={!hasPrevPage}
          id="prev_page"
        >
          <IconArrow />
        </Button>

        {pageButtons}

        <Button
          title="Next page"
          key={"Next"}
          onClick={onNextPage}
          disabled={!hasNextPage}
          id="next_page"
        >
          <IconArrow direction="right" />
        </Button>
        <Button
          title="Go to Last Page"
          key={"Last"}
          onClick={onLastPage}
          disabled={!hasNextPage}
          id="last_page"
        >
          Last
          <IconArrow leftpadded direction="right" />
        </Button>
      </ButtonBar>

      <DisplayRowsSelector>
        <span id='sRecordsPerPage'>Records per page</span>
        <Select
          id="select_number_pages"
          title="Change number of rows displaying"
          value={displaying}
          onChange={event => onChangeDisplaying(Number(event.target.value))}
        >
          {displayOptions.map((option, index) => (
            <option key={option} id={`rows_per_page_${index}`}>{option}</option>
          ))}
        </Select>
      </DisplayRowsSelector>
    </Container>
  );
};

UIPagination.propTypes = {
  activePage: PropTypes.number,
  startPage: PropTypes.number,
  endPage: PropTypes.number,
  hasNextPage: PropTypes.bool,
  hasPrevPage: PropTypes.bool,
  displaying: PropTypes.number,
  displayOptions: PropTypes.arrayOf(PropTypes.number),
  onChangePage: PropTypes.func,
  onNextPage: PropTypes.func,
  onPrevPage: PropTypes.func,
  onFirstPage: PropTypes.func,
  onLastPage: PropTypes.func,
  onChangeDisplaying: PropTypes.func
};

UIPagination.defaultProps = {
  activePage: 1,
  startPage: 1,
  endPage: 1,
  hasNextPage: false,
  hasPrevPage: false,
  displaying: 0,
  displayOptions: [],
  onChangePage: defaultPropFunction,
  onNextPage: defaultPropFunction,
  onPrevPage: defaultPropFunction,
  onFirstPage: defaultPropFunction,
  onLastPage: defaultPropFunction,
  onChangeDisplaying: defaultPropFunction
};

export default UIPagination;
